import { useCallback } from "react";
import { PageRoutes } from "../../../constants/routes";
import { useNavigation } from "../../../hooks/useNavigation";

export const useResetPasswordTimeOut = () => {
  const { navigateToPage } = useNavigation();

  const handleResetPasswordTimeOut = useCallback(() => {
    navigateToPage(PageRoutes.FORGOT_PASSWORD);
  }, [navigateToPage]);

  return { handleResetPasswordTimeOut };
};
